var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"home"},[_c('title-block'),_c('stages-block'),_c('tech-block'),_c('a',{attrs:{"name":"props","id":"props"}}),_c('props-block'),_c('contact-block'),_c('footer-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }